import { Observable } from 'rxjs';
import { IBaseService } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';

export interface IAuthenticationDataService extends IBaseService {

    authenticateUserName$(mandator: string, userName: string): Observable<any>;
    authenticateUserNameAsync(mandator: string, userName: string): Promise<any>;

    authenticateUser$(mandator: string, userName: string, password: string): Observable<IDtoUser>;
    authenticateUserAsync(mandator: string, userName: string, password: string): Promise<IDtoUser>;

    resetPasswordForUser$(mandator: string, userName: string, password: string): Observable<IDtoUser>;
    resetPasswordForUserAsync(mandator: string, userName: string, password: string): Promise<IDtoUser>;

}
